import { render, staticRenderFns } from "./EditPlaceholderProductModal.vue?vue&type=template&id=314ae538&"
import script from "./EditPlaceholderProductModal.vue?vue&type=script&lang=js&"
export * from "./EditPlaceholderProductModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports